import confirmTemplate from '@/plugins/confirm/ConfirmTemplate.vue'

/* eslint-disable prefer-promise-reject-errors */
export default {
  install(Vue) {
    let ConfirmConstructor = Vue.extend(confirmTemplate)
    let confirmInstance = null
    Vue.prototype.$confirm = config => {
      return new Promise((resolve, reject) => {
        if (confirmInstance) return
        confirmInstance = new ConfirmConstructor({
          el: document.createElement('div'),
          data() {
            return {
              title: config.title || '',
              message: config.message || '',
              underText: config.underText || '',
              confirmText: config.confirmText || 'Sair',
              cancelText: config.cancelText || 'Inserir outro',
              confirmColor: config.confirmColor || 'error',
              cancelColor: config.cancelColor || undefined,
              dark: config.dark || false,
              icon: config.icon || false
            }
          },
          methods: {
            onConfirm() {
              confirmInstance.open = false
              confirmInstance = null
              resolve()
            },
            onCancel() {
              confirmInstance.open = false
              confirmInstance = null
              reject && reject('')
            }
          }
        })
        confirmInstance.open = true
        document.body.appendChild(confirmInstance.$el)
      })
    }
  }
}
